<template>
  <div>
    <el-dialog :visible.sync="state" title="开户主体管理" width="666px" :close-on-click-modal="false" append-to-body>
      <div class="c-form">
        <el-form label-width="140px" inline>
          <el-form-item>
            <el-button type="text" icon="el-icon-plus" @click="addModal = true">新建主体</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table class="common-el-table-styles" :data="data" height="360" v-loading="loading" style="width: 100%" border stripe>
          <el-table-column prop="id" label="主体ID" width="100" />
          <el-table-column prop="companyName" label="主体名称" />
          <el-table-column label="操作" width="100" align="center">
            <template #default="{ row }">
              <el-popconfirm title="删除将不可恢复，是否继续？" @confirm="handleDelete(row.id)">
                <el-button slot="reference" type="text" size="small">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="state = false">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="addModal" title="新建主体" width="666px" :close-on-click-modal="false" append-to-body>
      <el-form label-width="140px" @submit.native.prevent>
        <el-form-item label="开户主体名称">
          <el-input v-model.trim="companyName" placeholder="最多100个字符" maxlength="100" style="width: 360px" size="small" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="btnLoading" @click="handleAdd">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue'
import { Message } from 'element-ui'
import { isEmpty } from '@/common/js/utils'
import { queryCompanyList, deleteCompanyBody as deleteCompanyBodyApi, addCompanyBody as addCompanyBodyApi } from '@/api/sysmana.model'
// eslint-disable-next-line
const props = defineProps({
  value: {
    type: Boolean,
    default: false
  }
})
// eslint-disable-next-line
const emit = defineEmits(['input', 'on-refresh-data'])

// State
const loading = ref(false)
const btnLoading = ref(false)
const data = ref([])
const addModal = ref(false)
const companyName = ref('')

// Computed
const state = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('input', val)
  }
})

// Methods
const getData = () => {
  loading.value = true
  queryCompanyList()
    .then((res) => {
      loading.value = false
      if (res) {
        data.value = res
      } else {
        Message.error('查询错误！')
      }
    })
    .catch(() => {
      loading.value = false
      Message.error('查询出错！')
    })
}

const handleDelete = (id) => {
  deleteCompanyBodyApi({ id }).then((res) => {
    if (res) {
      Message.success('删除成功')
      getData()
    } else {
      Message.error('删除失败！')
    }
  })
}

const handleAdd = () => {
  if (isEmpty(companyName.value)) {
    Message.warning('公司主体名不可为空！')
    return
  }
  btnLoading.value = true
  addCompanyBodyApi({ companyName: companyName.value })
    .then((res) => {
      btnLoading.value = false
      if (res) {
        Message.success('新建成功')
        companyName.value = ''
        addModal.value = false
        getData()
      } else {
        Message.error('新建失败！')
      }
    })
    .catch(() => {
      btnLoading.value = false
      Message.error('新建出错！')
    })
}

// Watchers
watch(
  () => props.value,
  (nVal, oVal) => {
    if (nVal) {
      getData()
    } else if (oVal && !nVal) {
      emit('on-refresh-data')
    }
  }
)
</script>

<style lang="scss" scoped>
.c-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
::v-deep .el-dialog__body {
  padding-top: 0;
}
</style>
